import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, VolumeX, XCircle } from 'lucide-react';
const FAILED_METHODS = ['Repetir la orden 10 veces solo le enseña que no tiene que escucharte hasta la décima.', 'Amenazar con quitar la tablet por un comportamiento no relacionado no enseña responsabilidad, solo genera resentimiento.', 'El "vete a tu cuarto" aísla al niño en el momento que más necesita guía para autorregularse.', 'Gritar más fuerte solo apaga el oído del niño y activa su instinto de defensa o bloqueo.'];
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-92">
      <div className="max-w-3xl mx-auto px-6" data-id="element-93">
        {/* Hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-sage-50 rounded-3xl p-8 md:p-12 mb-16 shadow-sm border border-sage-100" data-id="element-94">
          <p className="text-lg md:text-xl leading-relaxed text-stone-700 mb-6 font-medium" data-id="element-95">
            ¿Alguna vez has sentido ese calor que sube por tu cuello cuando, por
            quinta vez, tu hijo ignora una instrucción simple? En ese momento,
            el cansancio del día se mezcla con la frustración y terminas dando
            un grito que te duele más a ti que a ellos.
          </p>
          <p className="text-lg md:text-xl leading-relaxed text-stone-700" data-id="element-96">
            <strong className="text-sage-700" data-id="element-97">
              No eres un mal padre por perder la calma.
            </strong>{' '}
            Simplemente estás usando herramientas agotadas para un cerebro
            infantil que no está diseñado para procesar órdenes bajo presión. La
            buena noticia es que hay una forma de recuperar el control de tu
            hogar sin sacrificar la paz mental de tu familia.
          </p>
        </motion.div>

        {/* The Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-98">
          <div className="flex items-center gap-3 mb-6" data-id="element-99">
            <VolumeX className="w-8 h-8 text-amber-500" data-id="element-100" />
            <h2 className="font-serif text-3xl md:text-4xl text-navy" data-id="element-101">
              El Verdadero Problema
            </h2>
          </div>
          <div className="space-y-6 text-lg text-stone-600 leading-relaxed" data-id="element-102">
            <p data-id="element-103">
              El problema no es que tu hijo sea "rebelde" o "malo". El problema
              es la <strong data-id="element-104">sordera selectiva biológica</strong>. Cuando repites
              lo mismo una y otra vez, el cerebro de tu hijo aprende a filtrarte
              como si fueras ruido de fondo.
            </p>
            <p data-id="element-105">
              Y cuando finalmente gritas, su cerebro entra en modo de
              supervivencia (lucha o huida), bloqueando por completo la parte
              lógica que se encarga de obedecer.{' '}
              <em data-id="element-106">Estás gritándole a una puerta cerrada.</em>
            </p>
            <p className="font-medium text-stone-800 bg-amber-50 p-4 rounded-xl border border-amber-100" data-id="element-107">
              El resultado es siempre el mismo: obediencia por miedo, culpa
              inmediata para ti y una conexión familiar que se debilita cada
              día.
            </p>
          </div>
        </motion.div>

        {/* Failed Methods */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-108">
          <h3 className="font-serif text-2xl md:text-3xl text-navy mb-8 text-center" data-id="element-109">
            Por qué lo que has intentado no funciona
          </h3>
          <div className="grid gap-4" data-id="element-110">
            {FAILED_METHODS.map((method, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-stone-50 p-5 rounded-2xl" data-id="element-111">
                <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-112" />
                <p className="text-stone-700" data-id="element-113">{method}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}